import React from 'react'
import { THtmlElementHeading } from '@/types/HtmlElements'

type TProps = {
  children: React.ReactNode
  id?: string
  tag: THtmlElementHeading
}

function TaxonomyHeading({ children, id, tag }: TProps) {
  const Tag = tag

  return (
    <Tag
      className="text-2xl font-semibold text-gray-1100 md:text-3xl"
      id={id}
    >
      {children}
    </Tag>
  )
}

export default TaxonomyHeading
